import Modal from 'react-bootstrap/Modal';
import { useState, useEffect } from 'react';
import axios from 'axios';
import { Button } from 'react-bootstrap';

export default function DoYouKnow() {
  const [modalShow, setModalShow] = useState(false);
  const [questions, setQuestions] = useState([]);
  const [answers, setAnswers] = useState([]);
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    setModalShow(true);
    loadQuestions();
  }, []);

  const loadQuestions = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_PATH}prompt-questions?page=1&size=10`);
      if (res.status !== +process.env.REACT_APP_RECORD_NOT_FOUND) {
        const { error, data } = res.data;
        if (!error && Array.isArray(data)) setQuestions(data);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleAnswerChange = (questionId, value) => {
    setMessage('');
    setAnswers(prev => {
      const existing = prev.find(ans => ans.questionId === questionId);
      if (existing) {
        return prev.map(ans =>
          ans.questionId === questionId ? { ...ans, answer: value } : ans
        );
      }
      return [...prev, { questionId, answer: value }];
    });
  };

  const validateForm = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    // const phoneRegex = /^0\d{9}$/; // Adjust as per your country's format
    const phoneRegex = /^(0\d{10}|\+234\d{10})$/;
  
    if (!email || !phone) {
      setMessage('Email and phone are required.');
      return false;
    }
  
    if (!emailRegex.test(email)) {
      setMessage('Please enter a valid email.');
      return false;
    }
  
    if (!phoneRegex.test(phone)) {
      setMessage('Please enter a valid phone number (e.g., 0801234567).');
      return false;
    }
  
    if (answers.length !== questions.length) {
      setMessage('Please answer all questions.');
      return false;
    }
  
    return true;
  };
  

  const submitAnswers = async () => {
    if (!validateForm()) return;

    try {
      setSubmitting(true);
      const res = await axios.post(`${process.env.REACT_APP_API_PATH}prompt-answers/create`, {
        email,
        phone,
        data: answers
      });
      setSubmitting(false);
      const { error, message } = res.data;
      alert(message);
      if (!error) {
        setEmail('');
        setPhone('');
        setModalShow(false);
      }
    } catch (err) {
      setSubmitting(false);
      const { data } = err.response || {};
      let msg = data?.message || err.message || 'An error occurred.';
      if (Array.isArray(data) && data.length > 0) {
        msg = data[0].msg;
      }
      setMessage(msg);
      alert(msg);
    }
  };

  if (!questions.length) return null;

  return (
    <Modal
      show={modalShow}
      onHide={() => setModalShow(false)}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Do you know we can help you achieve your real estate goals?
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="container">
          <div className="text-center h6 mb-4">
            Please answer all the questions below to get started
          </div>

          {questions.map((q, i) => (
            <div key={q.id} className="my-3">
              <strong>Question {i + 1}:</strong> {q.question} <span className="text-danger">*</span>
              <div>
                {['Yes', 'No'].map(option => (
                  <label key={option} className="me-3">
                    <input
                      type="radio"
                      name={`question-${q.id}`}
                      value={option}
                      onChange={() => handleAnswerChange(q.id, option)}
                      checked={answers.find(ans => ans.questionId === q.id)?.answer === option}
                      required
                    />{' '}
                    {option}
                  </label>
                ))}
              </div>
            </div>
          ))}

          <div className="my-3">
            <input
              className="form-control"
              placeholder="Your email *"
              name="email"
              type="email"
              value={email}
              onChange={e => {
                setEmail(e.target.value);
                setMessage('');
              }}
              required
            />
          </div>

          <div className="my-3">
            <input
              className="form-control"
              placeholder="Your phone *"
              name="phone"
              type="tel"
              value={phone}
              onChange={e => {
                setPhone(e.target.value);
                setMessage('');
              }}
              required
            />
          </div>

          {message && (
            <div className="text-center text-danger fw-bold my-3">{message}</div>
          )}
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button onClick={submitAnswers} disabled={submitting}>
          {submitting ? 'Submitting...' : 'Submit'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}